/**
 * 추천 카테고리 타일의 3D 아트·짧은 라벨(10-15) — 검색바 "무엇을" 칸과 카테고리 시트 추천 줄이
 * 같이 쓴다. 정식 이름은 길어(예 "전통의상 (한복/기모노 등)") 한 줄 타일에 넣을 수 없어 이 줄에서만
 * 줄여 부른다. 라벨은 `searchComposer.promotedShort.<shortKey>`. 여기 없는 추천 코드는 선 아이콘 +
 * 정식 이름으로 그린다.
 */
export type PromotedShortKey =
  | "phone"
  | "kpop"
  | "traditional"
  | "bicycle"
  | "motorcycle"
  | "tent"
  | "camping"
  | "car";

export const PROMOTED_TILE_ART: Record<string, { src: string; shortKey: PromotedShortKey }> = {
  "20-01": { src: "/icons/categories/home-smartphone-3d-v3-160.webp", shortKey: "phone" },
  "10-06": { src: "/icons/categories/home-lightstick-3d-v2-160.webp", shortKey: "kpop" },
  "10-05-01": {
    src: "/icons/categories/home-traditional-clothing-3d-v1-160.webp",
    shortKey: "traditional",
  },
  "50-01-03": { src: "/icons/categories/home-bicycle-3d-balanced-160.webp", shortKey: "bicycle" },
  "50-01-02": { src: "/icons/categories/home-motorcycle-3d-v1-160.webp", shortKey: "motorcycle" },
  "10-04-02": { src: "/icons/categories/home-tent-set-3d-v1-160.webp", shortKey: "tent" },
  "10-04": { src: "/icons/categories/home-camping-equipment-3d-v1-160.webp", shortKey: "camping" },
  "50-03-03": { src: "/icons/categories/home-car-rental-3d-v1-160.webp", shortKey: "car" },
};
